import { Box, Divider, Stack, Text } from '@mantine/core';
import React from 'react';

interface LogItemProps {
  showLine?: boolean;
  history?: string;
  reason?: string;
  status?: string;
}

const LogItem: React.FC<LogItemProps> = ({ showLine = true, history, reason, status }) => {
  return (
    <>
      <Box p={8} className='log-item'>
        <Stack gap={0} w={240}>
          <Text fz={12}>{history}</Text>
          <Text fz={12}>Status : {status}</Text>
          <Text fw={600} truncate='end'>
            {reason}
          </Text>
        </Stack>
      </Box>
      {showLine && <Divider c={'dark'} />}
    </>
  );
};

export default LogItem;
